import { ClientEvent } from '@udemy/event-tracking';
export class ReviewLabsBannerDismissed extends ClientEvent {
  constructor({
    isMultipleLabsBanner
  }) {
    super('ReviewLabsBannerDismissed');
    this.isMultipleLabsBanner = void 0;
    this.isMultipleLabsBanner = isMultipleLabsBanner;
  }
}
//# sourceMappingURL=review-labs-banner-dimissed.js.map